
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import SettingService from "api/services/SettingService";
import SectionBanner from "components/cards/SectionBanner";
import AddCategory from "./category/AddCategory";
import EditCategory from "./category/EditCategory";
import OnDeleteConfirm from "components/modals/OnDeleteConfirm";
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import SectionWrapper from "components/wrappers/SectionWrapper";
import { BiChevronRightCircle } from 'react-icons/bi'
import TableContainer from "components/TableContainer";
import IMG_FAQ from 'assets/images/faq.svg'
import CategoryDetails from "./category/CategoryDetails";
import { getLanguage } from "utils/Utils";
import PageWrapper from "components/wrappers/PageWrapper";
import DashboardWrapper from "components/wrappers/DashboardWrapper";

import ToastAlert from "components/ToastAlert";
import PropTypes from 'prop-types';

function CategoryTitleCell({ value, column }) {
	return <div className="flex-1 text-sm">{value[column.languageKey]}</div>;
}
function FaqCountCell({ data, row }) {
	return <div className="flex-grow-0 text-sm">{data[row.id]?.faqs?.length}</div>;
}
function CategoryActionsHeader() {
	const { t } = useTranslation();
	return <div className="flex justify-end uppercase px-2">{t('table.actions')}</div>;
}
function CategoryActionsCell({ data, row, column }) {
	const id = data[row.id]?.id;
	const category = data[row.id];
	return (
		<div className="flex justify-end">
			<EditCategory key={"e3-12"} onUpdate={(newData) => column.onUpdate(id, newData)} data={category} />
			<OnDeleteConfirm onConfirm={() => column.onDelete(id)} key={"d3-1"} />
			<CategoryDetails data={category} />
			<NavLink exact
				to={`${column.url}/category/${id}`}
				className="block text-xl text-blue-500 cursor-pointer mx-1 p-2 rounded hover:bg-blue-100">
				<BiChevronRightCircle />
			</NavLink>
		</div>
	);
}

CategoryTitleCell.propTypes = {
	value: PropTypes.object,
	column: PropTypes.shape({ languageKey: PropTypes.string }),
};
FaqCountCell.propTypes = {
	data: PropTypes.array,
	row: PropTypes.shape({ id: PropTypes.string }),
};
CategoryActionsCell.propTypes = {
	data: PropTypes.array,
	row: PropTypes.shape({ id: PropTypes.string }),
	column: PropTypes.shape({ onUpdate: PropTypes.func, onDelete: PropTypes.func, url: PropTypes.string }),
};

const Faqs = () => {
	const { i18n, t } = useTranslation();
	const [remoteData, setRemoteData] = useState([])
	const [error, setError] = useState()
	const [loading, setLoading] = useState(true)
	let { url } = useRouteMatch();
	const cachedData = useMemo(() => (remoteData), [remoteData]);
	const [updateCategoryStatus, setUpdateCategoryStatus] = useState(null)
	const [addCategoryStatus, setAddCategoryStatus] = useState(null)
	const [deleteCategoryStatus, setDeleteCategoryStatus] = useState(null)

	const history = useHistory()

	const onDelete = (id) => {
		SettingService.deleteCategory(id).then((resp) => {
			setDeleteCategoryStatus("success")
			history.go()
		}).catch((err) => {
			//Handle error ..
			setDeleteCategoryStatus("error")

		});
	}

	const onCreate = (data) => {
		SettingService.createCategory(data).then((resp) => {
			setAddCategoryStatus("success")
			history.go()

		}).catch((err) => {
			//Handle error ..
			setAddCategoryStatus("error")

		});
	}

	const onUpdate = (id, data) => {
		SettingService.updateCategory(id, data).then((resp) => {
			setUpdateCategoryStatus("success")
			history.go()

		}).catch((err) => {
			//Handle error ..
			setUpdateCategoryStatus("error")
		});
	}

	const columns = useMemo(

		() => [
			// {
			//     Header: () => null,
			//     id: t('form.id'), // 'id' is required
			//     accessor: '_id'
			// },
			{
				Header: t('form.category'),
				accessor: "title",
				disableFilters: true,
				languageKey: getLanguage(i18n.language),
				Cell: CategoryTitleCell,
			},
			{
				Header: t('form.faq'),
				accessor: "faq",
				Cell: FaqCountCell,
			},
			{
				Header: CategoryActionsHeader,
				disableSortBy: true,
				accessor: "actions",
				url,
				onUpdate,
				onDelete,
				Cell: CategoryActionsCell,
			}
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[t]
	);

	useEffect(() => {
		SettingService.getCategoryList().then((resp) => {
			setRemoteData(resp)
			setLoading(false)
		}).catch((err) => {
			//Handle error ..
			setLoading(false)
			setError(err.message)
		});
		setAddCategoryStatus(null); setDeleteCategoryStatus(null); setUpdateCategoryStatus(null)

	}, []);

	return (
		<DashboardWrapper>
			<SectionBanner
				title={t('faqs.title')}
				desc={t('faqs.description')}
			>
				<img src={IMG_FAQ} alt='' height='100px' width='100px' />
			</SectionBanner>
			<SectionWrapper
				title={t('faqs.faq_categories')}
				actions={<AddCategory onCreate={onCreate} disabled={!!error} />}
				className="bg-white"
			>
				<PageWrapper error={error} loading={loading} >
					<TableContainer data={Array.isArray(cachedData) ? cachedData : []} columns={columns} globalSearch={true} />
				</PageWrapper>

			</SectionWrapper>

			{(addCategoryStatus === "success" || updateCategoryStatus === "success" || deleteCategoryStatus === "success")
				&& <ToastAlert message={t('alert.success_operation')} type={'success'} timeOut={5000} />}


			{(addCategoryStatus === "error" || updateCategoryStatus === "error" || deleteCategoryStatus === "error")
				&& <ToastAlert message={t('alert.failed_operation')} type={'error'} timeOut={5000} />}



		</DashboardWrapper>
	);
}

export default Faqs;


